import http from '../httpService';
import * as Axios from "axios";

export function getAllMonitoringFiles(cycleId) {
    return http.get(`/externalizations/${cycleId}/monitoring/files`)
}

export function downloadFile(externalizationAttachmentId, fileName) {
    return Axios({
        url: `externalizations-attachment/${externalizationAttachmentId}/download`,
        method: 'get',
        responseType: 'blob', // important
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        // link.target = "_blank"
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
    });
}

export function uploadMonitoringFile (cycleId, payload) {
  return http.post(`/externalizations/${cycleId}/monitoring/files`,payload)
}

export function uploadProponentFormFile (externalizationId,slotKey, payload) {
    return http.post(`/externalizations/${externalizationId}/proposal-form/${slotKey}`,payload)
}

export function deleteFile (externalizationAttachmentId) {
    return http.delete(`externalizations-attachment/${externalizationAttachmentId}`)
}

export function uploadITFFormFile (cycleId,slotKey, payload) {
  return http.post(`/externalizations/${cycleId}/itf-security-form/${slotKey}`,payload)
}